import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var u = ["beacon-area-chart", "beacon-bio-card", "beacon-article-tile", "beacon-byline", "beacon-button", "beacon-bar-chart", "beacon-carousel", "beacon-chart-tooltip", "beacon-chart-tooltip-data", "beacon-checkbox", "beacon-collection-tile", "beacon-contact-tile", "beacon-country", "beacon-country-selector", "beacon-data-list", "beacon-date-picker", "beacon-donut-chart", "beacon-dropdown", "beacon-error", "beacon-error-message-summary", "beacon-footer", "beacon-gauge-chart", "beacon-hero", "beacon-icon-button", "beacon-id-card", "beacon-input-button-field", "beacon-input-field", "beacon-key-facts", "beacon-legacy-collection-tile", "beacon-legend", "beacon-legend-item", "beacon-line-chart", "beacon-modal", "beacon-navigation", "beacon-navigation-button", "beacon-navigation-expanded", "beacon-navigation-footer", "beacon-navigation-popover", "beacon-navigation-toolbelt", "beacon-paginated-tabs", "beacon-popover", "beacon-promo-tile", "beacon-quote-block", "beacon-radio-button", "beacon-radio-group", "beacon-region-selector", "beacon-scatter-chart", "beacon-social-link", "beacon-social-link-container", "beacon-stepper", "beacon-tab", "beacon-tab-panel", "beacon-tabbed-hero", "beacon-table", "beacon-table-caption", "beacon-table-header", "beacon-table-record", "beacon-table-stub", "beacon-tabs", "beacon-text-area", "beacon-toggle-button-field", "beacon-tooltip", "beacon-value-prop", "beacon-video", "beacon-video-tag", "beacon-video-transcript"],
  l = {
    allComponents: u
  },
  x = function x(t) {
    return t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function (e, a) {
      return (a ? "-" : "") + e.toLowerCase();
    });
  },
  j = function j(t) {
    return /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(t);
  };
function g(t) {
  return "".concat(t).toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), function (e, a, n) {
    return "".concat(a.toUpperCase() + n);
  }).replace(new RegExp(/\w/), function (e) {
    return e.toUpperCase();
  });
}
var h = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function v(t) {
  switch (t) {
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./register-chunks/index-925c1461.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./register-chunks/index-8621d35a.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./register-chunks/index-616559a7.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./register-chunks/index-3ee1dbd5.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./register-chunks/index-2e575327.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./register-chunks/index-174ff784.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./register-chunks/index-d648440a.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./register-chunks/index-48265952.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./register-chunks/index-48cf4f86.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./register-chunks/index-3a85dfa7.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./register-chunks/index-c0431eff.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./register-chunks/index-b6dfa2ae.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./register-chunks/index-dab0a113.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./register-chunks/index-31116766.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./register-chunks/index-3fb019ea.js");
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./register-chunks/index-a13fa12b.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./register-chunks/index-53a75b2e.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./register-chunks/index-1116cedb.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./register-chunks/index-3bc31bd2.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./register-chunks/index-bb959da6.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./register-chunks/index-f670279d.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./register-chunks/index-f22bbef1.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./register-chunks/index-852b587d.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./register-chunks/index-d2faf00c.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./register-chunks/index-0aa054bb.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./register-chunks/index-fdce7dff.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./register-chunks/index-79b32863.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./register-chunks/index-fe619f0e.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./register-chunks/index-5830cbb3.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./register-chunks/index-3123a23e.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./register-chunks/index-da6421db.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./register-chunks/index-356374c7.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./register-chunks/index-c7822671.js").then(function (e) {
        return e.index;
      });
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./register-chunks/index-06211a59.js").then(function (e) {
        return e.index;
      });
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./register-chunks/index-06211a59.js").then(function (e) {
        return e.index$1;
      });
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./register-chunks/index-06211a59.js").then(function (e) {
        return e.index$2;
      });
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./register-chunks/index-25a4efec.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./register-chunks/index-06211a59.js").then(function (e) {
        return e.index$3;
      });
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./register-chunks/index-06211a59.js").then(function (e) {
        return e.index$4;
      });
    case "./__temp-separated/beacon-paginated-tabs/index.js":
      return import("./register-chunks/index-8508ad8a.js");
    case "./__temp-separated/beacon-popover/index.js":
      return import("./register-chunks/index-d9181bd9.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./register-chunks/index-6a3e3fd5.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./register-chunks/index-764047ed.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./register-chunks/index-f78fb393.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./register-chunks/index-6f518176.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./register-chunks/index-16afb1ca.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./register-chunks/index-f85b4c57.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./register-chunks/index-e96ccfbc.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./register-chunks/index-7084b5cb.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./register-chunks/index-29db6773.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./register-chunks/index-9a400caf.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./register-chunks/index-17d25074.js");
    case "./__temp-separated/beacon-tabbed-hero/index.js":
      return import("./register-chunks/index-d60c1fdf.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./register-chunks/index-3d8b9ae4.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./register-chunks/index-d800634b.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./register-chunks/index-1db9ff1c.js").then(function (e) {
        return e.index;
      });
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./register-chunks/index-ee0613f6.js").then(function (e) {
        return e.index;
      });
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./register-chunks/index-97530075.js").then(function (e) {
        return e.index;
      });
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./register-chunks/index-98277422.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./register-chunks/index-5890508d.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./register-chunks/index-b755caee.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./register-chunks/index-c87bdc4c.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./register-chunks/index-b159d590.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./register-chunks/index-b7bfc09d.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./register-chunks/index-ca4b4e07.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./register-chunks/index-fe0b99fd.js");
    default:
      return new Promise(function (e, a) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(a.bind(null, new Error("Unknown variable dynamic import: " + t)));
      });
  }
}
var b = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var t,
        e,
        a,
        n,
        c,
        s,
        o,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            t = _args.length > 0 && _args[0] !== undefined ? _args[0] : "";
            e = _args.length > 1 && _args[1] !== undefined ? _args[1] : document.body;
            a = t ? t + "-beacon-" : "beacon-", n = e instanceof Element ? e.tagName.toLowerCase() : "", c = n == null ? void 0 : n.startsWith(a), s = _toConsumableArray(e.querySelectorAll(":not(:defined)")).map(function (r) {
              return r.tagName.toLowerCase();
            }).filter(function (r) {
              return r.startsWith(a);
            });
            c && !customElements.get(n) && s.push(n);
            o = _toConsumableArray(new Set(s)).map(function (r) {
              return t ? r.split("".concat(t, "-"))[1] : r;
            });
            _context.t0 = o.length;
            if (!_context.t0) {
              _context.next = 9;
              break;
            }
            _context.next = 9;
            return y(t, o);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function b() {
      return _ref.apply(this, arguments);
    };
  }(),
  f = function f(t) {
    var e = x(t);
    return j(t) || console.warn("Beacon Warning: '".concat(t, "' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name \"").concat(e, "\".")), e;
  },
  w = function w(t) {
    var e = f(t);
    return {
      tagName: e,
      className: g(e)
    };
  },
  p = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(t, e, a) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (n, c) {
              var s;
              if (typeof e == "string") {
                var _w = w(e),
                  o = _w.tagName,
                  r = _w.className;
                customElements.get(t + o) ? n(customElements.get(t + o)) : v("./__temp-separated/".concat(o, "/index.js")).then(function (m) {
                  var d;
                  var i = m["".concat(r)];
                  i.registerComponent(t), (d = i.nestedComponents) != null && d.length && Promise.all(i.nestedComponents.map(function (_) {
                    return p(t, _, a);
                  })), n(i);
                }).catch(function () {
                  a && c(new Error("Beacon Registration Error: Unable to import ".concat(e)));
                });
              } else if (e.registerComponent) {
                var _o = e;
                _o.registerComponent(t), (s = _o.nestedComponents) != null && s.length && Promise.all(_o.nestedComponents.map(function (r) {
                  return p(t, r, a);
                })), n(_o);
              }
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function p(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }(),
  y = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var t,
        e,
        a,
        n,
        _args3 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            t = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : "";
            e = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
            a = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : !h;
            n = e.length ? e : l.allComponents;
            _context3.next = 6;
            return Promise.all(n.map(function (c) {
              return p(t, c, a);
            }));
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function y() {
      return _ref3.apply(this, arguments);
    };
  }(),
  C = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var t,
        e,
        _args5 = arguments;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            t = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : "";
            e = new MutationObserver( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(a) {
                var _iterator, _step, n, _iterator2, _step2, c;
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _iterator = _createForOfIteratorHelper(a);
                      _context4.prev = 1;
                      _iterator.s();
                    case 3:
                      if ((_step = _iterator.n()).done) {
                        _context4.next = 26;
                        break;
                      }
                      n = _step.value.addedNodes;
                      _iterator2 = _createForOfIteratorHelper(n);
                      _context4.prev = 6;
                      _iterator2.s();
                    case 8:
                      if ((_step2 = _iterator2.n()).done) {
                        _context4.next = 16;
                        break;
                      }
                      c = _step2.value;
                      _context4.t0 = c.nodeType === Node.ELEMENT_NODE;
                      if (!_context4.t0) {
                        _context4.next = 14;
                        break;
                      }
                      _context4.next = 14;
                      return b(t, c);
                    case 14:
                      _context4.next = 8;
                      break;
                    case 16:
                      _context4.next = 21;
                      break;
                    case 18:
                      _context4.prev = 18;
                      _context4.t1 = _context4["catch"](6);
                      _iterator2.e(_context4.t1);
                    case 21:
                      _context4.prev = 21;
                      _iterator2.f();
                      return _context4.finish(21);
                    case 24:
                      _context4.next = 3;
                      break;
                    case 26:
                      _context4.next = 31;
                      break;
                    case 28:
                      _context4.prev = 28;
                      _context4.t2 = _context4["catch"](1);
                      _iterator.e(_context4.t2);
                    case 31:
                      _context4.prev = 31;
                      _iterator.f();
                      return _context4.finish(31);
                    case 34:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4, null, [[1, 28, 31, 34], [6, 18, 21, 24]]);
              }));
              return function (_x4) {
                return _ref5.apply(this, arguments);
              };
            }());
            _context5.next = 4;
            return b(t);
          case 4:
            e.observe(document.documentElement, {
              subtree: !0,
              childList: !0
            });
            return _context5.abrupt("return", e);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function C() {
      return _ref4.apply(this, arguments);
    };
  }();
export { C as autoLoadBeaconComponents, w as getComponentIdentifiers, f as getComponentTagName, p as importAndRegisterComponent, y as registerBeaconComponents };